import React, { createContext, useState, useEffect } from 'react';
import translations from '../translations/translations';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'he';
  });

  const isHebrew = language === 'he';

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'he' ? 'en' : 'he'));
  };

  const t = (section, key) => {
    const entry = translations[section]?.[key];
    if (!entry) return '';
    if (typeof entry === 'string') return entry;
    return entry[language] || entry.he || '';
  };

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
    document.documentElement.dir = isHebrew ? 'rtl' : 'ltr';
  }, [language, isHebrew]);

  return (
    <LanguageContext.Provider value={{ language, isHebrew, toggleLanguage, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};
